import React, { SVGProps } from "react";
export default function SupForge(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 1V1.21947C1 4.92033 3.46796 8.14733 7 9.13846V10.2008C7 11.4169 6.36871 12.5459 5.33261 13.1827L2.37558 15H2V15.2308L1 15.8454V19H19V15.2199L14.8316 12.6668C14.315 12.3503 14 11.7881 14 11.1822C14 9.83447 14.6818 8.5782 15.8118 7.84369L19 5.77134V1H1ZM5 2H2.04197C2.26518 4.06553 3.36454 5.90163 5 7.08149V2ZM6 7.68604C6.50387 7.93724 7.04347 8.13242 7.61169 8.26263L8 8.35162V10.2008C8 11.7644 7.18834 13.2159 5.85621 14.0346L4.28543 15H16.7264L14.3093 13.5195C13.4959 13.0213 13 12.1361 13 11.1822C13 9.49599 13.853 7.92422 15.2668 7.00525L18 5.22866V2H6V7.68604ZM2 16.4046L2.65831 16H18V18H2V16.4046Z"
        fill="currentColor"
      />
    </svg>
  );
}
